import React, { useState, useRef, useEffect } from 'react';
import { User, Globe, LogOut } from 'lucide-react';
import profileImg from "../assets/profile-image.jpg";
import { Link, useNavigate } from 'react-router-dom';

export const ProfileDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navagate = useNavigate();
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClick = () =>
  {
    sessionStorage.removeItem('token');
    navagate("/auth/login?logout=true");
  }
  return (
    <div className="relative" ref={dropdownRef}>
      <button 
        className="size-10 overflow-hidden rounded-full"
        onClick={() => setIsOpen(!isOpen)}
      >
        <img
          src={profileImg}
          alt="profile image"
          className="size-full object-cover"
        />
      </button>
      
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            <Link
              to="/profile" 
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <User size={16} className="mr-2" />
              Profile
            </Link>
            <Link 
              to="/" 
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <Globe size={16} className="mr-2" />
              See Website
            </Link>
            <button 
              className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              onClick={handleClick}
            >
              <LogOut size={16} className="mr-2" />
              Logout
            </button>
          </div>
        </div>
      )}
    </div>
  );
};